export default __webpack_public_path__ + "static/media/Ballroll_00337.5987f83d.png";